export function checkStepCompleted() {
    let activeStep = $(`.steps__step.is--active`);
    allRequiredFilled(activeStep) ? makeStepReady(activeStep) : makeStepNotReady(activeStep);
    checkParents(activeStep);
}

function checkParents(step) {
    $(`.is--active`).parent().children().each(function () {
        if ($(this).hasClass('is--active')) {
            return false;
        }
        if (!$(this).hasClass('ready')) {
            allRequiredFilled($(this)) ? makeStepReady($(this)) : $(this).addClass('required');
        }
    })
}
function getRequiredFields(step) {
    changeBundleRequired();
    let datastep = step.data(`step`);
    return $(`.content[data-step='${datastep}']`).find('[data-required=1]');
}

function changeBundleRequired() {
    let requiredOriginal = $(`[data-required-orginal=1]`);
    let orginal = $(requiredOriginal).data("requiredOrginal");
    if ($(requiredOriginal).children().filter(function() { return $(this).css("display") != "none" }).length == 0) {
        $(requiredOriginal).attr('data-required', 0);
    } else {
        $(requiredOriginal).attr('data-required', orginal);
    }
}

function makeStepReady(step) {
    step.addClass(`ready`);
    step.removeClass(`required`);
}

function makeStepNotReady(step) {
    step.removeClass(`ready`);

}

function allRequiredFilled(step) {
    let counter = 0;
    let requiredFields = getRequiredFields(step);
    requiredFields.each(function (i) {
        let innerCounter = 0;
        innerCounter += $(this).find(`input:checked`).length;
        ($(this).find(`input[type=number], select`).val()) ? innerCounter++ : '';
        if ($(this).find(`.item__text__content`).length != 0) {
            ($(this).find(`.item__text__content`).first().text() != "Geen keuze gemaakt") ? innerCounter++ : '';
        }

        if (innerCounter > 0) counter++;
    });
    return requiredFields.length == counter ? true : false;
}

